// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EditEntity from '../../components/CRUD/EditEntity';

const UpdateFareMediaBatch = () => {
  return (
    <EditEntity
      pageTitle="EditFareMediaBatch"
      fetchApiUrl="/api/v1/web_portal/fare_media_policy_capping/fare_media_batches/:id"
      fetchApiMethod="GET"
      dataPath="data.data"
      inputs={[
        {
          name: 'label',
          labelKey: 'BatchLabel',
          inputType: 'text',
          required: true,
        },
        {
          name: 'note',
          labelKey: 'Notes',
          inputType: 'text',
          required: false,
        }
      ]}
      dropdowns={[]} // Organisation cannot be updated in the backend
      updateApiUrl="/api/v1/web_portal/fare_media_policy_capping/fare_media_batches/:id"
      updateApiMethod="PATCH"
      successMessage="FareMediaBatchUpdatedSuccessfully"
      successUrl="/CardsManagement/fare-media-batches"
      backUrl="/CardsManagement/fare-media-batches/:id"
      subsystemName="FareMediaBatches"
      permissionSystem="masterConfig"
    />
  );
};

export default UpdateFareMediaBatch;
